export enum ViewType {
  TrackRollup = 'TrackRollup',
  Derivative = 'Derivative',
  Territories = 'Territories',
}
